export default "__VITE_ASSET__BeFmB4WH__"